import * as React from 'react'

import FormRow from 'modules/core/components/FormRow'
import { LeaveTypeSelectorInput } from 'modules/core/components/Inputs/LeaveTypeSelectorInput'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import type ReportsForm from 'modules/employees/lib/forms/Reports'
import leaveTypes from 'modules/timeoff/store/collections/leaveTypes'

interface Props {
  form: ReportsForm
}

const ExportLeaveSelector = ({ form }: Props) => {
  useAsyncData(async () => {
    await leaveTypes.fetch()
  }, [])
  const visibleLeaveTypes = leaveTypes.active

  const onSelectLeaveTypes = (leaveTypeIds: number[]) => {
    form.setValues({
      leave_type_ids: leaveTypeIds,
    })
  }

  return (
    <>
      <FormRow>
        <LeaveTypeSelectorInput
          label={i18n.t('employees.reports.select_absence_types')}
          attachment="middle center"
          leaveTypes={visibleLeaveTypes}
          selectedIds={[]}
          onSubmit={onSelectLeaveTypes}
          showCreateLeave={visibleLeaveTypes.length === 0}
          mandatory
        />
      </FormRow>
    </>
  )
}

export default ExportLeaveSelector
